import * as React from 'react';
import { ReservationSubPane } from '../../atoms/reservations/ReservationPane';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './reservationActionPane.module.scss';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
  submitting: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: () => any;
  disable?: boolean;
};
export const ReservationActionPane = observer(({ submitting, onSubmit, disable = false }: Props) => (
  <ReservationSubPane styleName="pane">
    <div styleName="text">
      この内容でよろしければ、{GlobalStatesV3.viewport.isDesktop && <br />}予約を確定しましょう
    </div>
    <div styleName="button-wrapper">
      <Button
        id="confirm-reserve"
        styleName="button"
        type="primary"
        size="m"
        loading={submitting}
        onClick={onSubmit}
        disabled={disable}
      >
        予約を確定する
      </Button>
    </div>
  </ReservationSubPane>
));
